import gql from 'graphql-tag';

const ISS_SYNC_CLUB = gql`
mutation issSyncClub($clubId: ID!, $background: Boolean) {
  issSyncClub(clubId: $clubId, background: $background) 
}
`;

export default ISS_SYNC_CLUB;